import React from 'react';
import { InfoIcon } from 'lucide-react';
import { ArticleSection } from './ArticleSection';
import { CompanyCard } from './CompanyCard';
import { companies } from '../../data/companies';
export function CompanyProfiles() {
  return <ArticleSection id="top-companies" title="Top 5 AI Workflow Automation Service Providers in England" data-id="element-35" data-mp="8zbpv6645s5b">
      <p data-id="element-36" data-mp="4z1ltz1vtbt3">
        Each provider below takes a different route to the same goal: fewer manual handoffs, faster
        turnaround and processes people can trust. Some lead with engineering, some with consultancy and
        some with a specific platform. The right one depends on your systems, risk appetite and how much
        of the work you want to own afterwards.
      </p>
      <aside className="flex gap-3 rounded-2xl border border-line bg-night-800/70 p-4" aria-label="Methodology note" data-id="element-37" data-mp="3hi13560k3m98">
        <InfoIcon className="mt-1 h-4 w-4 shrink-0 text-aurora-cyan" aria-hidden="true" data-id="element-38" data-mp="3debhopf6hksf" />
        <p className="!text-[0.95rem] !leading-7" data-id="element-39" data-mp="38gjprvej9yo8">
          This order is our own editorial selection based on publicly available service information from each
          company. No third-party organisation ranked these providers, and we have deliberately left out
          ratings, awards and client claims we cannot independently verify.
        </p>
      </aside>

      <div className="!mt-8 space-y-6" data-id="element-40" data-mp="11epulahksac1">
        {companies.map(company => <CompanyCard key={company.name} company={company} data-id="element-41" data-mp="1p5bqk3eb245o" />)}
      </div>
    </ArticleSection>;
}